/**
 *
 * Whenever a change is made here in the mapping or in the light colors list,
 * please notify Marcella so that we will stay in sync.
 */

const colorMapping = {
  38919: '#f5deb3', // beige (color)
  38920: '#2196f3', // blau (color)
  38921: '#795548', // braun (color)
  38922: '#B79E6E', // bronze (color)
  38923: '#ffeb3b', // gelb (color)
  38924: '#ffd700', // gold (color)
  38925: '#9e9e9e', // grau (color)
  38926: '#4caf50', // gruen (color)
  38927: '#9c27b0', // lila (color)
  38928: '#FE7D7E', // mischfarben (color)
  38929: '#ff9800', // orange (color)
  38930: '#e91e63', // pink (color)
  38931: '#f44336', // rot (color)
  38932: '#000000', // schwarz (color)
  38933: '#CFD1D0', // silber (color)
  38934: '#f2f2f2', // transparent (color)
  38935: '#ffffff', // weiss (color)
  38875: '#ffb6c1', // altrosa (colorDetail)
  38807: '#3E3F41', // anthrazit (colorDetail)
  38829: '#adff2f', // apfel (colorDetail)
  38855: '#FFB385', // apricot (colorDetail)
  38758: '#00ffff', // aqua (colorDetail)
  38838: '#330033', // aubergine (colorDetail)
  38756: '#1AADEA', // azur (colorDetail)
  38810: '#8C92A0', // basaltgrau (colorDetail)
  38846: '#990033', // beere (colorDetail)
  38734: '#E1D1B2', // beige (colorDetail)
  38746: '#C1B2A1', // beigemeliert (colorDetail)
  38747: '#0000ff', // blau (colorDetail)
  38770: '#70778B', // blaumeliert (colorDetail)
  38765: '#6495ed', // blue_denim (colorDetail)
  38884: '#DF1126', // blutrot (colorDetail)
  38882: '#8C0E1D', // bordeaux (colorDetail)
  38771: '#663300', // braun (colorDetail)
  38786: '#544138', // braunmeliert (colorDetail)
  38781: '#9E8369', // brokat (colorDetail)
  38847: '#531D65', // brombeer (colorDetail)
  38787: '#B79E6E', // bronze (colorDetail)
  38886: '#AE394A', // burgunder (colorDetail)
  38737: '#D3AB85', // camel (colorDetail)
  38782: '#CA9C70', // cappuccino (colorDetail)
  38741: '#FCEFCE', // chamois (colorDetail)
  38739: '#F8F2D7', // champagner (colorDetail)
  38776: '#B54D16', // cognac (colorDetail)
  38897: '#D2353C', // cranberry (colorDetail)
  38735: '#EFE4CB', // creme (colorDetail)
  38792: '#FFC421', // curry (colorDetail)
  38762: '#008b8b', // cyanblau (colorDetail)
  38845: '#660033', // cyclam (colorDetail)
  38745: '#C0B49B', // dunkelbeige (colorDetail)
  38769: '#00008b', // dunkelblau (colorDetail)
  38785: '#4c2002', // dunkelbraun (colorDetail)
  38801: '#fbd621', // dunkelgelb (colorDetail)
  38817: '#6C6D6A', // dunkelgrau (colorDetail)
  38835: '#006400', // dunkelgruen (colorDetail)
  38851: '#9400d3', // dunkellila (colorDetail)
  38864: '#ff8c00', // dunkelorange (colorDetail)
  38879: '#CC0066', // dunkelpink (colorDetail)
  38903: '#8b0000', // dunkelrot (colorDetail)
  38742: '#F2E6D2', // ecru (colorDetail)
  38916: '#F0F0F0', // eierschale (colorDetail)
  38738: '#FEFDE5', // elfenbein (colorDetail)
  38759: '#2631b2', // enzian (colorDetail)
  38874: '#e485bb', // eosin (colorDetail)
  38895: '#b22222', // feuerrot (colorDetail)
  38840: '#d8bfd8', // flieder (colorDetail)
  38867: '#ff00ff', // fuchsia (colorDetail)
  38789: '#ffff00', // gelb (colorDetail)
  38802: '#C59828', // gelbmeliert (colorDetail)
  38803: '#ffd700', // gold (colorDetail)
  38794: '#FACD4E', // goldgelb (colorDetail)
  38808: '#4C4D4F', // graphit (colorDetail)
  38831: '#7cfc00', // grasgruen (colorDetail)
  38805: '#b7b7b7', // grau (colorDetail)
  38818: '#807D84', // graumeliert (colorDetail)
  38813: '#D2CFC7', // greige (colorDetail)
  38883: '#BA052E', // grenadine (colorDetail)
  38819: '#008000', // gruen (colorDetail)
  38836: '#5B7A35', // gruenmeliert (colorDetail)
  38744: '#FCF5E8', // hellbeige (colorDetail)
  38768: '#add8e6', // hellblau (colorDetail)
  38784: '#A66827', // hellbraun (colorDetail)
  38800: '#ffffe0', // hellgelb (colorDetail)
  38816: '#E1E1DF', // hellgrau (colorDetail)
  38834: '#98fb98', // hellgruen (colorDetail)
  38850: '#CCCCFF', // helllila (colorDetail)
  38863: '#FFB573', // hellorange (colorDetail)
  38878: '#ff69b4', // hellpink (colorDetail)
  38902: '#F74848', // hellrot (colorDetail)
  38871: '#F3466A', // himbeer (colorDetail)
  38764: '#87ceeb', // himmelblau (colorDetail)
  38793: '#EEBF6E', // honig (colorDetail)
  38859: '#F55C26', // hummer (colorDetail)
  38751: '#4b0082', // indigo (colorDetail)
  38827: '#457950', // jade (colorDetail)
  38772: '#CF8625', // karamell (colorDetail)
  38889: '#800000', // karminrot (colorDetail)
  38773: '#A64A2C', // kastanienbraun (colorDetail)
  38820: '#bdb76b', // khaki (colorDetail)
  38892: '#C62831', // kirschrot (colorDetail)
  38740: '#E1D7C3', // kitt (colorDetail)
  38828: '#9acd32', // kiwi (colorDetail)
  38898: '#F50D1A', // knallrot (colorDetail)
  38753: '#0000cd', // kobaltblau (colorDetail)
  38857: '#ff7f50', // koralle (colorDetail)
  38788: '#BA6E4E', // kupfer (colorDetail)
  38860: '#fa8072', // lachs (colorDetail)
  38843: '#CC99FF', // lavendel (colorDetail)
  38837: '#800080', // lila (colorDetail)
  38852: '#38172A', // lilameliert (colorDetail)
  38821: '#32cd32', // limette (colorDetail)
  38795: '#E1D544', // limone (colorDetail)
  38870: '#CC3366', // magenta (colorDetail)
  38856: '#EB7A35', // mandarine (colorDetail)
  38748: '#13255A', // marine (colorDetail)
  38841: '#C699AD', // mauve (colorDetail)
  38899: '#F76663', // melone (colorDetail)
  38893: '#7C0001', // merlot (colorDetail)
  38825: '#D4F3DD', // mint (colorDetail)
  38853: '#FE7D7E', // mischfarben (colorDetail)
  38783: '#7A6A58', // mokka (colorDetail)
  38754: '#191970', // nachtblau (colorDetail)
  38915: '#ECEAE4', // naturweiss (colorDetail)
  38749: '#000080', // navy (colorDetail)
  38766: '#25CAF8', // neonblau (colorDetail)
  38798: '#F5FD37', // neongelb (colorDetail)
  38832: '#00ff00', // neongruen (colorDetail)
  38848: '#F200FF', // neonlila (colorDetail)
  38861: '#FF7900', // neonorange (colorDetail)
  38876: '#FF00CC', // neonpink (colorDetail)
  38900: '#FF2700', // neonrot (colorDetail)
  38736: '#E7CCB6', // nude (colorDetail)
  38777: '#BE7817', // ocker (colorDetail)
  38913: '#E8E2DB', // offwhite (colorDetail)
  38822: '#808000', // oliv (colorDetail)
  38757: '#7B98BD', // opal (colorDetail)
  38854: '#ffa500', // orange (colorDetail)
  38865: '#D4591C', // orangemeliert (colorDetail)
  38891: '#ff4500', // orangerot (colorDetail)
  38844: '#da70d6', // orchidee (colorDetail)
  38890: '#B34018', // oxid (colorDetail)
  38767: '#D4EBF8', // pastellblau (colorDetail)
  38799: '#FFFFC1', // pastellgelb (colorDetail)
  38833: '#CEECBF', // pastellgruen (colorDetail)
  38849: '#e6e6fa', // pastelllila (colorDetail)
  38862: '#FFC490', // pastellorange (colorDetail)
  38877: '#FFE4E4', // pastellpink (colorDetail)
  38901: '#FF9C9C', // pastellrot (colorDetail)
  38912: '#EEEDE9', // perlweiss (colorDetail)
  38823: '#008080', // petrol (colorDetail)
  38858: '#ffdab9', // pfirsich (colorDetail)
  38839: '#dda0dd', // pflaume (colorDetail)
  38866: '#ff1493', // pink (colorDetail)
  38880: '#EC5F87', // pinkmeliert (colorDetail)
  38869: '#F979A2', // pitaya (colorDetail)
  38909: '#B7B0B0', // platin (colorDetail)
  38873: '#F3CCB8', // puder (colorDetail)
  38779: '#D8A36E', // pueblo (colorDetail)
  38894: '#dc143c', // purpur (colorDetail)
  38752: '#708090', // rauchblau (colorDetail)
  38812: '#B9B9B9', // rauchgrau (colorDetail)
  38872: '#FFD4CF', // ros (colorDetail)
  38868: '#ffc0cb', // rosa (colorDetail)
  38804: '#EBBCA8', // rosegold (colorDetail)
  38775: '#AB3E1D', // rostbraun (colorDetail)
  38885: '#B14224', // rostrot (colorDetail)
  38881: '#ff0000', // rot (colorDetail)
  38904: '#BA2345', // rotmeliert (colorDetail)
  38896: '#c71585', // rotviolett (colorDetail)
  38760: '#4169e1', // royalblau (colorDetail)
  38888: '#A4050C', // rubinrot (colorDetail)
  38796: '#E5B129', // safran (colorDetail)
  38743: '#F8F0E2', // sand (colorDetail)
  38755: '#3F5C9B', // saphir (colorDetail)
  38815: '#9E9DA2', // grey_denim (colorDetail)
  38826: '#2e8b57', // schilf (colorDetail)
  38809: '#6E6663', // schlammfarben (colorDetail)
  38774: '#59362A', // schoko (colorDetail)
  38905: '#000000', // schwarz (colorDetail)
  38907: '#252525', // schwarzmeliert (colorDetail)
  38790: '#DDB33C', // senf (colorDetail)
  38778: '#DCAC6A', // sepia (colorDetail)
  38906: '#303030', // black_denim (colorDetail)
  38908: '#CFD1D0', // silber (colorDetail)
  38917: '#EBE9EF', // white_denim (colorDetail)
  38811: '#c0c0c0', // silbergrau (colorDetail)
  38824: '#008b8b', // smaragd (colorDetail)
  38814: '#BEBEBE', // stone (colorDetail)
  38830: '#306C44', // tanne (colorDetail)
  38763: '#b0c4de', // taubenblau (colorDetail)
  38806: '#B5AC9E', // taupe (colorDetail)
  38910: '#f3eeee', // transparent (colorDetail)
  38750: '#40e0d0', // tuerkis (colorDetail)
  38761: '#06129B', // ultramarinblau (colorDetail)
  38780: '#935520', // umbra (colorDetail)
  38842: '#483d8b', // violettblau (colorDetail)
  38887: '#7B0E2A', // weinrot (colorDetail)
  38911: '#ffffff', // weiss (colorDetail)
  38918: '#D1D1D7', // weissmeliert (colorDetail)
  38914: '#F1E9DD', // wollweiss (colorDetail)
  38791: '#FFE055', // zitrone (colorDetail)
  38797: '#F8F657', // zitronengelb (colorDetail)
};

export type DetailColorId = keyof typeof colorMapping;

export const detailColorToHexCode = (id: DetailColorId) => {
  const code = colorMapping[id];
  if (!code) {
    console.warn(`Cannot resolve color code for \`${id}\``);
    return null;
  }
  return code;
};

const lightColors: number[] = [
  38741, // chamois (colorDetail)
  38739, // champagner (colorDetail)
  38738, // elfenbein (colorDetail)
  38874, // eosin (colorDetail)
  38799, // pastellgelb (colorDetail)
  38744, // hellbeige (colorDetail)
  38919, // beige (color)
  38734, // beige (colorDetail)
  38800, // hellgelb (colorDetail)
  38743, // sand (colorDetail)
  38910, // transparent (colorDetail)
  38911, // weiss (colorDetail)
  38935, // weiss (color)
  38934, // transparent (color),
  38923, // gelb (color)
  38789, // gelb (colorDetail)
  38915, // naturweiss (colorDetail)
  38912, // perlweiss (colorDetail)
  38914, // wollweiss (colorDetail)
  38918, // weissmeliert (colorDetail)
  38735, // creme (colorDetail)
  38825, // mint (colorDetail)
];

export const isLightColor = (id: number): boolean => lightColors.includes(id);

export const isDetailColorId = (
  value: string | number,
): value is DetailColorId => {
  if (typeof value === 'string') {
    value = Number(value);
  }

  return Object.keys(colorMapping).map(Number).includes(value);
};

const grayCodeId: DetailColorId = 38925; // grau (color)
const whiteCodeId: DetailColorId = 38935; // weiss (color)
const multiColorId: DetailColorId = 38928; // mischfarben (color)
const bronzeColorId: DetailColorId = 38922; // bronze (color)
const goldColorId: DetailColorId = 38924; // gold (color)
const silverColorId: DetailColorId = 38933; // silber (color)

const gradientColors: DetailColorId[] = [
  bronzeColorId,
  goldColorId,
  silverColorId,
];

const getBorderColor = (id: DetailColorId, defaultColor: string): string => {
  if (id === whiteCodeId) {
    const colorHexCode = detailColorToHexCode(grayCodeId);

    if (!colorHexCode) {
      return defaultColor;
    }

    return colorHexCode;
  }

  return defaultColor;
};

type ColorType = 'constant' | 'gradient' | 'multicolor';

export const boxColorComposition = (
  id: DetailColorId,
): {
  borderColor: string;
  colorPattern: string;
  colorType: ColorType;
} | null => {
  const colorHexCode = detailColorToHexCode(id);

  if (!colorHexCode) {
    return null;
  }

  if (gradientColors.includes(id)) {
    const baseGradient = {
      borderColor: 'transparent',
      colorType: 'gradient' as ColorType,
    };

    switch (id) {
      case bronzeColorId:
        return {
          ...baseGradient,
          colorPattern: 'radial-gradient(circle at 100% 0, #e6b895, #ff7043)',
        };

      case goldColorId:
        return {
          ...baseGradient,
          colorPattern: 'radial-gradient(circle at 100% 0, #f7e7ce, #b78628)',
        };

      case silverColorId:
        return {
          ...baseGradient,
          colorPattern: 'radial-gradient(circle at 100% 0, #e8e8e8, #bfbfbf)',
        };
    }
  }

  if (id === multiColorId) {
    return {
      borderColor: 'transparent',
      colorPattern: `linear-gradient(45deg, #ff9800, #ff9800 100%),
      linear-gradient(135deg, #4caf50, #4caf50),
      linear-gradient(225deg, #f44336, #f44336),
      linear-gradient(225deg, #2196f3, #2196f3)`,
      colorType: 'multicolor',
    };
  }

  return {
    borderColor: getBorderColor(id, colorHexCode),
    colorPattern: colorHexCode,
    colorType: 'constant',
  };
};
